import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-patient-list",
  templateUrl: "./patient-list.component.html",
})
export class PatientListComponent implements OnInit {
  rowsData = [
    {
      title: "First Name",
      sorting: true,
      name: "patientFirstName",
      underline: true,
    },
    {
      title: "Last Name",
      sorting: true,
      name: "patientLastName",
      underline: true,
    },
    { title: "Telephone" },
    {
      title: "Date of Service",
      sorting: true,
      name: "scheduledOn",
      dateFitler: true,
    },
    { title: "Patient Type", hyperlink: true },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "createdOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  startDate = "";
  endDate = "";
  countryData = [];
  stateData = [];
  countryidadmin: any = "";
  stateidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";
  selectedState: any = "";
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllCountry();
    if (
      sessionStorage.getItem("startDate") &&
      sessionStorage.getItem("endDate")
    ) {
      this.startDate = sessionStorage.getItem("startDate");
      this.endDate = sessionStorage.getItem("endDate");
    } else {
      this.startDate = "";
      this.endDate = "";
    }
    this.getAllPatientsListAdmin("");

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllPatientsListAdmin(event);
      }
    });
    this.checkUrl();
  }

  navigateToDashboard() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "dashboard",
    ]);
  }

  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  getAllStateByCountry(countryid) {
    this.appService.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.getAllPatientsListAdmin("");
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.selectedState = "";
    this.getAllPatientsListAdmin("");
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllPatientsListAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.selectedCountry = "";
    this.selectedState = "";
    this.stateidadmin = "";
    this.countryidadmin = "";

    this.getAllPatientsListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllPatientsListAdmin("");
  }

  getAllPatientsListAdmin(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        patientType: "all",
        search: this.searchPatient,
        tcId: "",
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        patientType: "all",
        search: this.searchPatient,
        tcId: "",
        startDate: this.startDate,
        endDate: this.endDate,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    }

    this.appService.getpatientlistbytcWithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData = this.columnsData.concat({
                param1: obj.patientFirstName ? obj.patientFirstName : "-",
                param2: obj.patientLastName ? obj.patientLastName : "-",
                param3:
                  obj.patientPhone && obj.patientPhoneCode === "+91"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2")
                    : obj.patientPhone && obj.patientPhoneCode === "+1"
                    ? obj.patientPhoneCode +
                      " " +
                      obj.patientPhone.replace(
                        /^(\d{0,3})(\d{0,3})(\d{0,4})/,
                        "($1) $2-$3"
                      )
                    : "-",
                param4: obj.scheduledOnStr ? obj.scheduledOnStr : "-",
                param5: obj.patientType
                  ? obj.patientType === "IC"
                    ? "IC"
                    : "SchedMed"
                  : "-",
                param6: obj.patientId ? obj.patientId : "-",
                param7: obj.tcId || obj.testcenterId || obj.testCenterId || obj.centerId || "",
                param8: obj.tcName || obj.name || obj.testCenterName || obj.centerName || "",
                param9: obj.patientType === "IC"
                  ? "IC"
                  : (obj.tcName || obj.name || obj.testCenterName || obj.centerName)
                    ? "SM"
                    : "",
                param13: "Double click for edit",
              });
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllPatientsListAdmin(event);
  }
}
